import { OK } from 'http-status-codes';
import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import logGAEvent from '../helpers/logGAEvent';
import EVENT_ACTIONS from '../constants/EVENT_ACTIONS';

/**
 * This function posts the TC String to the back end for
 * record keeping
 */
const postUserConsent = async (gdprConsentString) => {
  const customPurposes = gdprConsentString.tcModel.publisherCustomConsents.set_;
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'same-origin',
    // @ts-ignore
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-mp-xsrf': GDPRConfig.xsrfToken,
    },
    body: JSON.stringify({
      consentString: gdprConsentString.getTCString(),
      customPurposes: Array.from(customPurposes.values()),
    }),
  };

  try {
    const response = await fetch('/consent/storeUserConsentV2', fetchOptions);
    const data = await response.json();

    if (response.status !== OK) {
      logGAEvent(EVENT_ACTIONS.POST_TC_STRING_FAILED);
      return false;
    }

    logGAEvent(EVENT_ACTIONS.POST_TC_STRING_SUCCESS);

    return data.success;
  } catch (error) {
    logGAEvent(EVENT_ACTIONS.POST_TC_STRING_THREW_ERROR);
    return false;
  }
};

export default postUserConsent;
